import {Component, inject, Input, OnDestroy, OnInit, PLATFORM_ID, ChangeDetectionStrategy} from '@angular/core';
import {isPlatformBrowser, NgClass} from '@angular/common';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {filter, Subscription} from 'rxjs';
import {CategoryDropdownItem, DropdownItem} from '@components/navbar/navbar.component';
import {FeatureFlagService} from '@services/feature-flag.service';
import {TranslatePipe} from '@ngx-translate/core';

const ACTIVE_ROUTE_PREFIXES = ['/bet', '/collection'];

@Component({
  selector: 'peps-category-dropdown-button',
	imports: [
		NgClass,
		RouterLinkActive,
		RouterLink,
		TranslatePipe,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './category-dropdown-button.component.html',
})
export class CategoryDropdownButtonComponent implements OnInit, OnDestroy {

  	constructor() {}

	private featureFlagService = inject(FeatureFlagService);
	private readonly router = inject(Router);
	private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

	@Input() text: string = '';
	@Input() items: CategoryDropdownItem[] = [];
	@Input() isMobileNavbar = false;
	@Input() route: string = '';

	isOpen = false;
	isMobile = false;
	isActiveCategory = false;

	private routerSub!: Subscription;

	select(action: () => void) {
		action();
		if(this.isMobile) {
			this.isOpen = false;
		}
	}

	ngOnInit() {
		if (this.isBrowser) {
			// Doit matcher le breakpoint xl du tiroir mobile de la navbar : en dessous,
			// le panneau desktop (hover-only, lg:flex) n'est jamais accessible au tactile.
			this.isMobile = window.innerWidth < 1280;
			window.addEventListener('resize', this.updateDeviceMode.bind(this));
		}

		this.updateActiveCategory(this.router.url);
		this.routerSub = this.router.events
			.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
			.subscribe(event => this.updateActiveCategory(event.urlAfterRedirects));
	}

	ngOnDestroy() {
		if (this.isBrowser) window.removeEventListener('resize', this.updateDeviceMode.bind(this));
		this.routerSub?.unsubscribe();
	}

	private updateActiveCategory(url: string) {
		this.isActiveCategory = ACTIVE_ROUTE_PREFIXES.some(prefix => url.startsWith(prefix));
	}

	updateDeviceMode() {
		this.isMobile = window.innerWidth < 1280;
		if (!this.isMobile) this.isOpen = false;
	}

	handleClick() {
		if (this.isMobile) this.isOpen = !this.isOpen;
	}

	getFilteredItems(items: DropdownItem[]): DropdownItem[] {
		return items.filter(item => {
			if (!item.featureFlag) {
				return true;
			}
			return this.featureFlagService.isEnabled(item.featureFlag);
		});
	}

	isItemBeta(item: DropdownItem): boolean {
		if (!item.featureFlag) return false;
		return this.featureFlagService.isBeta(item.featureFlag);
	}
}
